/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import AutomateHeader from 'app/components/Headers/AutomateHeader.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import ConfirmPostRecentModal from 'app/components/common/ConfirmPostRecentModal.jsx';
import Content from 'app/components/common/Content.jsx';
import Loading from 'app/components/common/Loading.jsx';
import RouteListComponent from 'app/components/RouteList/RouteListComponent.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class AutomateView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			newSocial: null,
			routeCounts: {},
			reauthorizing: false,
		};

		this.reauthInput = this.reauthInput.bind(this);
		this.createNewRoute = this.createNewRoute.bind(this);
		this.postRecentQuiz = this.postRecentQuiz.bind(this);
		this.setMasterTwitterRole = this.setMasterTwitterRole.bind(this);
		this.setNewSocial = this.setNewSocial.bind(this);

	}

	componentDidMount() {

		let routeID = this.props.router.params.routeId,
			redirect = '/share/automate';

		if (routeID) {
			redirect = '/share/automate/detail/' + this.props.router.params.routeId;
		}

		this.props.getRoutes();
		this.props.getSocials();

		this.props.remoteReturnHandler([{
			method: 'POST',
			path: redirect,
			callback: (social) => {
				this.props.resetAuthState();
				this.setState({
					newSocial: social
				});
			}
		},
		{
			method: 'INPUT',
			path: redirect,
			callback: this.reauthInput
		}]);


	}

	componentDidUpdate(prevProps, prevState) {
		let errors = [],
			modalAdded = this.state.modalAdded;

		const clearSocialErrors = () => {
			this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
		};

		// a route was just deleted (deletion happens in SimpleRouteItemDetail)
		if (prevProps.automatedRoutes.list.length > this.props.automatedRoutes.list.length) {
			this.props.closeAllModals();
		} else if (prevProps.automatedRoutes.list.length < this.props.automatedRoutes.list.length && prevProps.app.loading.ROUTE_LIST === false && this.props.app.loading.ROUTE_LIST === false) {
			// new route will have been pushed onto the end of the route array
			let newRoute = this.props.automatedRoutes.list[this.props.automatedRoutes.list.length - 1];
			this.props.router.navigate('/share/automate/detail/' + newRoute.id);
		}

		// check inputsAvailable because a user may have spent all their feeds in curation
		if (prevProps.app.loading.ROUTE_LIST === true &&
			this.props.app.loading.ROUTE_LIST === false &&
			this.props.automatedRoutes.list.length === 0 &&
			parseInt(this.props.user.perms.resources.inputsAvailable) > 0) {
			let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
			if (onboarding !== null) {
				this.props.router.navigate('/welcome');
			} else {
				this.props.router.navigate('/share/automate/new/inputs');
			}
			//this.props.router.navigate('/share/automations');
		}

		if (prevState.reauthorizing === true && this.state.reauthorizing === true) {
			this.props.addMessage(UserMessages.generateMessage(UserMessages.input.reauthorized, 'INPUT_UPDATE'));
			this.setState({
				reauthorizing: false
			});
		}

		if (prevProps.app.loading.INPUT_REFRESH === true && this.props.app.loading.INPUT_REFRESH === false) {
			this.props.addMessage(UserMessages.generateMessage(UserMessages.route.created, 'INPUT_REFRESH'));
		}

		// check for and handle social creation errors
		if (this.props.isDuplicateSocial() && this.props.isDuplicateSocialModalVisible === false) {
			let social = null;
			if (this.state.newSocial !== null) {
				social = _.clone(this.state.newSocial);
			} else {
				for (let i = 0; i < this.props.app.errors.api.length; ++i) {
					let error = this.props.app.errors.api[i];
					if (['SOCIAL_CREATE', 'SOCIAL_UPDATE'].indexOf(error.type) !== -1 && error.post !== undefined) {
						social = _.clone(error.post);
					}
				}
			}
			this.props.showDuplicateSocialModal(social, {
				confirm: clearSocialErrors,
				cancel: clearSocialErrors
			});
		} else if (this.props.isBlacklisted() && this.props.isBlacklistModalVisible === false) {
			this.props.showBlacklistModal({
				confirm: clearSocialErrors,
				cancel: clearSocialErrors
			});
		} else if (this.props.isOverTheLimit() && this.props.isUpgradeModalVisible === false) {
			this.props.showUpgradeModal(this.props.closeAllModals, null, errors[0], 'automate_error');
		}

		if (prevProps.app.loading.SOCIAL_CREATE === true && this.props.app.loading.SOCIAL_CREATE === false) {
			let output = _.clone(this.state.newSocial),
				newSocialID = _.difference(_.pluck(this.props.socials.list, "id"), _.pluck(prevProps.socials.list, 'id'));

			if (output && newSocialID.length) {
				output.paID = newSocialID[0];

				this.setState({
					newSocial: null
				});

				this.postRecentQuiz(output);
			}

		}

		errors = this.props.getApiErrors(['OUTPUT_CREATE', 'OUTPUT_UPDATE']);
		if (errors.length) {
			let showTwitterError = false;

			if ((errors[0].errors !== undefined && errors[0].errors.validation.paID !== undefined && errors[0].errors.validation.paID.match("Twitter outputs")) ||
				(errors[0].errors !== undefined && errors[0].errors.validation.activeFlag !== undefined && errors[0].errors.validation.activeFlag.match("Twitter outputs"))) {
				showTwitterError = true;
			}

			if (showTwitterError) {
				this.props.addModal(
					<ConfirmModal
						{...this.props}
						modalCopy={"Only a single Twitter output is allowed in this type of route"}
						cancelAction={() => {
							this.props.deleteApiError(['OUTPUT_CREATE', 'OUTPUT_UPDATE']);
							this.props.closeAllModals();
						}}
						confirmAction={() => {
							this.props.deleteApiError(['OUTPUT_CREATE', 'OUTPUT_UPDATE']);
							this.props.closeAllModals();
						}}
						showCancel={false}
						confirmLabel={"OK"}/>
				);

				this.props.deleteApiError(['OUTPUT_CREATE', 'OUTPUT_UPDATE']);
			}

		}

		errors = this.props.getApiErrors(['INPUT_CREATE']);
		if (errors.length) {
			this.props.showUpgradeModal(this.props.closeAllModals, null, errors[0], 'automate_error');
			this.props.deleteApiError(['INPUT_CREATE']);
		}

	}

	reauthInput(input) {

		this.props.resetAuthState();
		input.routeId = this.props.router.params.routeId;
		this.props.updateInput(input);
		this.setState({
			reauthorizing: true
		});

	}

	createNewRoute(e){

		e.preventDefault();
		let trigger = 'automate-footer';

		if (e.target.className.match('new-icon')) {
			trigger = 'automate-banner';
		}

		if (this.props.user.perms.resources.inputsAvailable === 0) {
			this.props.showUpgradeModal(this.props.closeAllModals, 'inputs', null, trigger);
		} else {
			this.props.router.navigate('/share/automate/new/inputs');
		}

	}

	setMasterTwitterRole(output) {
		let constants = this.props.app.config.constants,
			route = null,
			twitterCount = 0;

		output.role = constants.OR_ROLE_RETWEET;

		for (var i = 0; i < this.props.automatedRoutes.list.length; ++i) {
			if (this.props.automatedRoutes.list[i].id == output.rID) {
				route = this.props.automatedRoutes.list[i];
				break;
			}
		}

		if (route) {
			for (i = 0; i < route.outputs.length; ++i) {
				if (route.outputs[i].social.psID == constants.POST_SVC_TWITTER) {
					++twitterCount;
					break;
				}
			}
		}

		if (twitterCount == 0) {
			output.role = constants.OR_ROLE_NORMAL;
		}

		return output;

	}

	postRecentQuiz(output) {
		let constants = this.props.app.config.constants;

		// if the paID is not defined and a new social is present assign it
		if (!output.paID && this.state.newSocial) {
			output.paID = this.state.newSocial;
			this.setState({
				newSocial: 0
			});
		}

		if (parseInt(output.psID, 10) === constants.POST_SVC_TWITTER) {
			output = this.setMasterTwitterRole(output);
		}

		let cancelConfirm = () => {
				this.props.createOutput(output);
				this.props.closeAllModals(null);
			},
			confirmConfirm = () => {
				output.postRecent = 1;
				this.props.createOutput(output);
				this.props.closeAllModals(null);
			},
			message = 'Would you like to share the most recent item to this social?',
			modal = (
				<ConfirmPostRecentModal
					modalCopy={message}
					cancelAction={cancelConfirm}
					confirmAction={confirmConfirm} />
			);

		this.props.addModal(modal);

	}

	setNewSocial(newSocial) {

		this.setState({
			newSocial
		});

	}

	render() {
		let RouteList = null,
			Header = (
				<AutomateHeader
					{...this.props}
					recordPath={this.props.recordPath}
					getSavedPath={this.props.getSavedPath}
					newRouteHandler={this.createNewRoute} />
			),
			outputId = 0,
			routeId = 0,
			route = null,
			routeName = "",
			constants = this.props.app.config.constants,
			type = constants.INPUT_TYPE_FEED;

		if (this.props.app.loading.ROUTE_LIST) {
			RouteList = <Loading/>;
		} else {
			RouteList = (
				<RouteListComponent
					{...this.props}
					newRouteInfo={this.state.newRouteInfo}
					recordPath={this.props.recordPath}
					newRouteHandler={this.createNewRoute}
					setNewSocial={this.setNewSocial} />
			);
		}

		return (
			<Content
				{...this.props}
				header={Header}
				main={RouteList} />
		);
	}

};

AutomateView.displayName = "Automate";

AutomateView.propTypes = {
	routeViewType: PropTypes.number,
	recordPath: PropTypes.func
};

AutomateView.defaultProps = {
	routeViewType: 0, // ROUTE_VIEW_ADVANCED
	recordPath: () => {}
};

export default ComponentWithContext(AutomateView);
